import { render, staticRenderFns } from "./ticketDetail.vue?vue&type=template&id=992fa192&scoped=true&"
import script from "./ticketDetail.vue?vue&type=script&lang=ts&"
export * from "./ticketDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ticketDetail.vue?vue&type=style&index=0&id=992fa192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992fa192",
  null
  
)

export default component.exports